"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpDataTableHeader = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const header_html_1 = __importDefault(require("./header.html"));
const constants = __importStar(require("./constants"));
const messages_1 = require("./messages");
const log = (0, debug_1.default)('itp:ui:components:datatable:header');
const LOG_RESIZE = false;
let ItpDataTableHeader = class ItpDataTableHeader extends vue_1.default {
    model;
    resizeStartPageX;
    resizingColumn;
    resizingElement;
    resizingColumnWidth;
    nextElement;
    nextColumnWidth;
    table;
    onDocumentMouseUp;
    onDocumentMouseMove;
    commandColumn;
    columns;
    tableId;
    minColumnWidth;
    rowDetails;
    onColumnsChanged() {
        this.calculateColumnWidths();
    }
    data() {
        return {
            ...constants,
            ...(0, messages_1.getMessages)(),
            resizeStartPageX: null,
            resizingElement: null,
            resizingColumn: null,
            resizingColumnWidth: null,
            nextColumnWidth: null
        };
    }
    mounted() {
        this.onDocumentMouseMove = (e) => {
            if (this.resizingElement &&
                this.resizeStartPageX &&
                this.resizingColumnWidth !== null) {
                var diffX = e.pageX - this.resizeStartPageX;
                if (this.nextElement && this.nextColumnWidth) {
                }
                const w = this.resizingColumnWidth + diffX;
                const minWidth = (this.resizingColumn && this.resizingColumn.minWidth) ||
                    this.minColumnWidth;
                if (w < minWidth) {
                    return;
                }
                const width = this.resizingColumnWidth + diffX + 'px';
                this.resizingElement.style.minWidth = width;
                this.resizingElement.style.width = width;
                LOG_RESIZE && log('diffX: %s, width: %s', diffX, width);
                if (this.resizingColumn) {
                    this.resizingColumn.width = width;
                    this.$nextTick(() => {
                        if (this.resizingElement) {
                            const TH = this.resizingElement;
                            const padding = getPaddingDiff(TH);
                            const resizingColumnWidth = TH.offsetWidth - padding;
                            LOG_RESIZE && log('resizingColumnWidth: %s', resizingColumnWidth);
                        }
                    });
                }
                this.$emit('resize', width);
            }
        };
        const onDocumentMouseUp = (ev) => {
            if (this.resizingElement) {
                document.removeEventListener('mousemove', this.onDocumentMouseMove);
                if (this.resizingColumn && this.resizingColumnWidth) {
                    const storeKey = this.getColumnWidthStoreKey(this.resizingColumn);
                    if (storeKey) {
                        this.$app.objectStore.setItem(storeKey, this.resizingColumn.width);
                    }
                    LOG_RESIZE && log('resizeEnd: %s', this.resizingColumn.name);
                }
                this.resizingElement = null;
                this.resizingColumn = null;
                this.resizingColumnWidth = null;
                this.nextColumnWidth = null;
                this.$emit('resizeEnd');
            }
        };
        document.addEventListener('mouseup', onDocumentMouseUp);
        this.$once('hook:beforeDestroy', () => {
            document.removeEventListener('mouseup', onDocumentMouseUp);
        });
        this.$nextTick(() => this.calculateColumnWidths());
    }
    getColumnWidthStoreKey(col) {
        if (this.tableId) {
            return `datatables.${this.tableId}.${col.field || col.name}.width`;
        }
    }
    getInitialComumnWidth(col) {
        if (col.systemColumn && col.width) {
            return col.width;
        }
        if (this.tableId && !this.table.noPersistState) {
            const key = this.getColumnWidthStoreKey(col);
            if (key) {
                const storedValue = this.$app.objectStore.getItem(key);
                if (storedValue && _.isString(storedValue)) {
                    return storedValue;
                }
            }
        }
        let width = col.width;
        if (_.isUndefined(width)) {
            width = col.width = '80px';
        }
        return width;
    }
    calculateColumnWidths() {
        const offset = this.rowDetails ? 1 : 0;
        const ths = Array.from(this.$el.querySelectorAll('tr > th'));
        let fillSpaceTH = null;
        for (let TH of ths) {
            const columnName = TH.dataset['column'];
            if (columnName == constants.COLNAME_FILL_SPACE) {
                fillSpaceTH = TH;
                continue;
            }
            if (columnName == constants.COLNAME_ROW_MENU) {
                continue;
            }
            const column = _.find(this.columns, { name: columnName });
            if (!column) {
                continue;
            }
            const width = this.getInitialComumnWidth(column);
            TH.style.width = width;
            TH.style.minWidth = width;
            _.set(TH.style, 'min-width', width);
            const eventArgs = {
                columnIndex: _.findIndex(this.columns, column),
                width: width,
                columnName
            };
            this.$nextTick(() => this.$emit('setSize', eventArgs));
        }
        if (fillSpaceTH) {
            fillSpaceTH.style.width = '100%';
        }
    }
    headerStyle(col) {
        if (col.width) {
            return {
                width: col.width,
                minWidth: col.width,
                maxWidth: col.width
            };
        }
    }
    sort(col) {
        return this.model.sortRows(col);
    }
    getSortIcon(col) {
        if (col.sort === -1) {
            return 'sort-up';
        }
        if (col.sort === 1) {
            return 'sort-down';
        }
        return 'sort';
    }
    mouseOverResizer(e, col) {
    }
    mouseOutResizer(e, col) {
    }
    mouseDownResizer(e, col) {
        if (this.resizingElement) {
            return;
        }
        const pageX = (this.resizeStartPageX = e.pageX);
        const TH = e.target.parentElement;
        if (!TH) {
            return;
        }
        this.resizingElement = TH;
        const padding = getPaddingDiff(TH);
        this.resizingColumnWidth = TH.offsetWidth - padding;
        LOG_RESIZE && log('mouseDownResizer; pageX: %s, padding: %s, width: %s', pageX, padding, this.resizingColumnWidth);
        const nextTH = (this.nextElement = TH.nextElementSibling);
        if (nextTH) {
            this.nextColumnWidth = nextTH.offsetWidth - padding;
            LOG_RESIZE && log('nextColumnWidth: %s', this.nextColumnWidth);
        }
        LOG_RESIZE && log('dataset: %o', TH.dataset);
        const columnIndex = whichChild(TH);
        const columnName = TH.dataset['column'];
        if (!columnName) {
            throw new Error("Missing 'data-column' attribute.");
        }
        if (!_.isNumber(columnIndex)) {
            throw new Error(`ColumnIndex must be a number: ${columnIndex}`);
        }
        const column = _.find(this.columns, { name: columnName });
        if (!column) {
            throw new Error(`Column not found. name=${columnName}`);
        }
        this.resizingColumn = column;
        const eventArgs = { columnName, columnIndex };
        LOG_RESIZE && log('emitting resizeStart: %o', eventArgs);
        this.$emit('resizeStart', eventArgs);
        document.addEventListener('mousemove', this.onDocumentMouseMove);
        e.stopPropagation();
        e.preventDefault();
    }
};
exports.ItpDataTableHeader = ItpDataTableHeader;
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableHeader.prototype, "commandColumn", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Array)
], ItpDataTableHeader.prototype, "columns", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpDataTableHeader.prototype, "tableId", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 40, type: Number }),
    __metadata("design:type", Number)
], ItpDataTableHeader.prototype, "minColumnWidth", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpDataTableHeader.prototype, "rowDetails", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)("columns"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpDataTableHeader.prototype, "onColumnsChanged", null);
exports.ItpDataTableHeader = ItpDataTableHeader = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: header_html_1.default,
        inject: ['table', 'model']
    })
], ItpDataTableHeader);
function getPaddingDiff(col) {
    if (getStyleVal(col, 'box-sizing') == 'border-box') {
        return 0;
    }
    const padLeft = getStyleVal(col, 'padding-left');
    const padRight = getStyleVal(col, 'padding-right');
    return parseInt(padLeft) + parseInt(padRight);
}
function getStyleVal(elm, css) {
    return window.getComputedStyle(elm, null).getPropertyValue(css);
}
function whichChild(elem) {
    if (elem) {
        var i = 0;
        while ((elem = elem.previousSibling) != null)
            ++i;
        return i;
    }
}
//# sourceMappingURL=header.js.map